import React from 'react';

export type ShareOptionProps = {
  icon: string;
  iconStyle?: string;
  color: string;
  background: string;
  onClick: () => void;
  label: string;
};

export default function ShareOption({
  icon,
  iconStyle = 'fab',
  color,
  background,
  onClick,
}: ShareOptionProps) {
  const style = {
    color: color,
    backgroundColor: background,
  };

  return (
    <div className='share-tab-option' style={style} onClick={onClick}>
      <i className={`${iconStyle} fa-${icon}`}></i>
    </div>
  );
}
